import { parseJSON } from '@/shared/parse';
import React from 'react';

export const useLocalStorageState = <T>(key: string, defaultValue: T) => {

  const [state, setState] = React.useState<T>(() => {
    const stored = localStorage.getItem(key);
    return stored ? parseJSON(stored, defaultValue) : defaultValue;
  });

  React.useEffect(() => {
    if (typeof state === 'undefined') {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(state));
    }
  }, [key, state]);

  return [state, setState] as const;
};